import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import { useNavigate, Link } from 'react-router-dom';
import Footer from './Footer.js';
import { Spinner, Alert } from 'react-bootstrap';
import { BASE_URL, BASE_URL1 } from './Constants.js';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const Focus_Report = () => {
  const [users, setUsers] = useState([]);
  const [users1, setUsers1] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [areas, setAreas] = useState([]);
  const [dressTypes, setDressTypes] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [colors, setColors] = useState([]);
  const [user, setUser] = useState([]);
  const [areaFilter, setAreaFilter] = useState('');
  const [focusFilter, setFocusFilter] = useState('');
  const [focusCodes, setFocusCodes] = useState([]);
  const [genderFilter, setGenderFilter] = useState('');
  const [dressTypeFilter, setDressTypeFilter] = useState('');
  const [sizeFilter, setSizeFilter] = useState('');
  const [colorFilter, setColorFilter] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const navigate = useNavigate();

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
const totalCount = filteredUsers.length;
  useEffect(() => {
    const fetchEmpList = async () => {
      const token = localStorage.getItem('authToken');

      if (!token) {
        setError('No token found!');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${BASE_URL}emp_list_code`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        if (data.status && Array.isArray(data.data)) {
          setUsers1(data.data);

          const user = data.data[0]; // assuming only one user is returned
          setUser(user.super_admin_role);


        } else {
          setError('Invalid response format');
        }
      } catch (err) {
        setError('Failed to fetch employee list');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchEmpList();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${BASE_URL}stocks_join`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();

        if (data.status && Array.isArray(data.data)) {
          setUsers(data.data);
          setFilteredUsers(data.data);
          setAreas([...new Set(data.data.map((item) => item.area))]);
          setFocusCodes([...new Set(data.data.map((item) => item.focus_code))]);
          setDressTypes([...new Set(data.data.map((item) => item.dress_type))]);
          setSizes([...new Set(data.data.map((item) => item.dress_size))]);
          setColors([...new Set(data.data.map((item) => item.dress_color))]);
        } else {
          setError('Invalid data format received.');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  const handleSearchAndFilter = (
    query = searchQuery,
    selectedArea = areaFilter,
    selectedGender = genderFilter,
     selectedFocus = focusFilter,
    selectedDressType = dressTypeFilter,
    selectedSize = sizeFilter,
    selectedColor = colorFilter
  ) => {
    const lowerQuery = query.toLowerCase();
    const filtered = users.filter((item) => {
      const matchesArea = !selectedArea || item.area === selectedArea;
      const matchesGender = !selectedGender || item.gender === selectedGender;
      const matchesFocus = !selectedFocus || item.focus_code === selectedFocus;
      const matchesDressType = !selectedDressType || item.dress_type === selectedDressType;
      const matchesSize = !selectedSize || item.dress_size === selectedSize;
      const matchesColor = !selectedColor || item.dress_color === selectedColor;
      const matchesSearch = Object.values(item).some(
        (val) => typeof val === 'string' && val.toLowerCase().includes(lowerQuery)
      );
      return matchesFocus && matchesArea && matchesGender && matchesDressType && matchesSize && matchesColor && matchesSearch;
    });

    setFilteredUsers(filtered);
    setCurrentPage(1);
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    handleSearchAndFilter(query);
  };

  const handleFilterChange = (setter, value, type) => {
    setter(value);
    handleSearchAndFilter(
      searchQuery,
      type === 'area' ? value : areaFilter,
      type === 'gender' ? value : genderFilter,
      type === 'focus' ? value : focusFilter,
      type === 'dressType' ? value : dressTypeFilter,
      type === 'size' ? value : sizeFilter,
      type === 'color' ? value : colorFilter
    );
  };

  const exportToExcel = () => {
    const dataToExport = filteredUsers.map((item, index) => ({
      'S/N': index + 1,
      'Area': item.area,
      'Gender': item.gender,
      'Dress Type': item.dress_type,
      'Size': item.dress_size,
      'Color': item.dress_color,
      'Focus Code': item.focus_code,
      'GRN Number': item.gnr_number,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Stock Data');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(dataBlob, 'stock_data.xlsx');
  };

  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) setIsSidebarOpen((prev) => !prev);
  };

  if (loading) return <div className="text-center my-5"><Spinner animation="border" /></div>;
  if (error) return <div className="text-center my-5"><Alert variant="danger">{error}</Alert></div>;



  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container" style={{ marginLeft: isSidebarOpen ? '300px' : '0' }}>
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div style={{ padding: '0 20px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h4>Focus Report</h4>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button className="btn btn-success" onClick={exportToExcel}>
                    <i className="fa fa-download"></i> Export to Excel
                  </button>
                  
                </div>
              </div>

              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '15px' }}>
                <label htmlFor="itemsPerPage">Items per page:</label>
                <select
                  id="itemsPerPage"
                  className="form-select"
                  style={{ width: '100px' }}
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1); // Reset to page 1 when changing items per page
                  }}
                >
                  <option value={10}>10</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={handleSearch}
                  style={{ width: '220px' }}
                />
                <select
  className="form-select"
  value={focusFilter}
  onChange={(e) => handleFilterChange(setFocusFilter, e.target.value, 'focus')}
  style={{ width: '180px' }}
>
  <option value="">All Focus Codes</option>
  {focusCodes.map((code, idx) => (
    <option key={idx} value={code}>{code}</option>
  ))}
</select>
                
              </div>


              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Area</th>
                      <th>Gender</th>
                      <th>Dress Type</th>
                      <th>Size</th>
                      <th>Color</th>
                      <th>GRN Number</th>
                      <th>Focus Code</th>
                      <th>GRN Image</th>
                      <th>Created By</th>
                      <th>Created On</th>
                     
                    </tr>
                  </thead>
                  <tbody>
                    {currentUsers.length > 0 ? currentUsers.map((item, index) => (
                      <tr key={item.id}>
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>{item.area}</td>
                        <td>{item.gender}</td>
                        <td>{item.dress_type}</td>
                        <td>{item.dress_size}</td>
                        <td>{item.dress_color}</td>
                        <td>{item.gnr_number}</td>
                        <td>{item.focus_code}</td>


                        <td>
                          {item.gnr_image ? (() => {
                            const ext = item.gnr_image.split('.').pop().toLowerCase();
                            const url = `${BASE_URL1}uploads/gnr_images/${item.gnr_image}`;
                            return ext === 'pdf' ? (
                              <a href={url} target="_blank" rel="noopener noreferrer">
                                <i className="fa fa-file-pdf-o fa-lg text-danger"></i>
                              </a>
                            ) : (
                              <a href={url} target="_blank" rel="noopener noreferrer">
                                <img src={url} alt="GNR" style={{ height: '40px', borderRadius: '4px' }} />
                              </a>
                            );
                          })() : 'No Image'}
                        </td>
                        <td>{item.created_by}</td>
                        <td>{item.created_at?.slice(0, 16)}</td>
                        
                      </tr>
                    )) : (
                      <tr><td colSpan="8" className="text-center">No data found</td></tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="d-flex justify-content-center mt-3">
                <div style = {{padding:'10px'}}><strong>Total Records: {totalCount}</strong></div>
                <button onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} className="btn btn-outline-secondary btn-sm mx-1" disabled={currentPage === 1}>Prev</button>
                {[...Array(totalPages).keys()].map(n => (
                  <button
                    key={n + 1}
                    onClick={() => setCurrentPage(n + 1)}
                    className={`btn btn-sm ${currentPage === n + 1 ? 'btn-primary' : 'btn-outline-secondary'} mx-1`}
                  >
                    {n + 1}
                  </button>
                ))}
                <button onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} className="btn btn-outline-secondary btn-sm mx-1" disabled={currentPage === totalPages}>Next</button>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Focus_Report;
